import angular from 'angular'
import checkImageModal from '../../app/input/inputInvoice/collection/view/checkImageModal.html'
import checkImageModalCtrl from '../../app/input/inputInvoice/collection/checkImageModalCtrl'

const dragModalModule = angular
    .module('app.dragModalModule', []).controller('checkImageModalCtrl', checkImageModalCtrl)

export default dragModalModule.name

dragModalModule.directive('dragBtn', ['$uibModal', ($uibModal) => ({
    restrict: 'E',
    replace: true,
    template: `
       <button class="btn btn-lg" ng-show="dragBtnShow" ng-click="imageShow()" type="button">查看影像</button>
    `,
    scope: {
        refList: '<',
        dragBtnShow: '<',
    },
    link(scope) {
        scope.imageShow = function imageShow() {
            const modalInstance = $uibModal.open({
                template: checkImageModal,
                controller: 'checkImageModalCtrl',
                animation: true,
                openedClass: 'checkImageModal',
                resolve: {
                    items1() {
                        return scope.refList
                    },
                },
                backdrop: false,
            })
            modalInstance.rendered.then(() => {
                startDrag('drag-title', 'modal-dialog', false)
            }, (reason) => {
                console.log(reason)// 点击空白区域，总会输出backdrop click，点击取消，则会暑促cancel
            })
        }
        /**
         * 纯js实现多div拖拽
         * @param bar, 拖拽触柄
         * @param target, 可拖动窗口
         * @param inWindow, 为true时只能在屏幕范围内拖拽
         * @param callback, 拖拽时执行的回调函数。包含两个参数，target的left和top
         * @returns {*}
         * @private
         */
        var startDrag = function (bar, target, /* optional */inWindow, /* optional */callback) {
            (function (bar, target, callback) {
                const D = document
                const DB = document.body
                const params = {
                    left: 0,
                    top: 0,
                    currentX: 0,
                    currentY: 0,
                }
                if (typeof bar === 'string') {
                    bar = D.getElementById(bar)
                }
                if (typeof target === 'string') {
                    target = D.getElementsByClassName(target)[0]
                }
                // bar.style.cursor="move";
                bindHandler(bar, 'mousedown', (e) => {
                    e.preventDefault()
                    params.left = target.offsetLeft
                    params.top = target.offsetTop
                    if (!e) {
                        e = window.event
                        bar.onselectstart = function () {
                            return false
                        }
                    }
                    params.currentX = e.clientX
                    params.currentY = e.clientY

                    var stopDrag = function () {
                        removeHandler(DB, 'mousemove', beginDrag)
                        removeHandler(DB, 'mouseup', stopDrag)
                    }; var
                        beginDrag = function (e) {
                            const evt = e || window.event
                            const nowX = evt.clientX
                            const nowY = evt.clientY
                            const disX = nowX - params.currentX
                            const disY = nowY - params.currentY
                            let left = parseInt(params.left) + disX
                            let top = parseInt(params.top) + disY
                            if (inWindow) {
                                const maxTop = DB.offsetHeight - target.offsetHeight
                                const maxLeft = DB.offsetWidth - target.offsetWidth
                                if (top < 0) top = 0
                                if (top > maxTop) top = maxTop
                                if (left < 0) left = 0
                                if (left > maxLeft) left = maxLeft
                            }
                            target.style.left = `${left}px`
                            target.style.top = `${top}px`

                            if (typeof callback === 'function') {
                                callback(left, top)
                            }
                        }

                    bindHandler(DB, 'mouseup', stopDrag)
                    bindHandler(DB, 'mousemove', beginDrag)
                })

                function bindHandler(elem, type, handler) {
                    if (window.addEventListener) {
                        // false表示在冒泡阶段调用事件处理程序
                        elem.addEventListener(type, handler, false)
                    } else if (window.attachEvent) {
                        // IE浏览器
                        elem.attachEvent(`on${type}`, handler)
                    }
                }

                function removeHandler(elem, type, handler) {
                    // 标准浏览器
                    if (window.removeEventListener) {
                        elem.removeEventListener(type, handler, false)
                    } else if (window.detachEvent) {
                        // IE浏览器
                        elem.detachEvent(`on${type}`, handler)
                    }
                }
            }(bar, target, inWindow, callback))
        }
    },
})])



// WEBPACK FOOTER //
// ./src/components/dragModal/index.js